import { Vehicle } from '@esportal/portal-service';
import React from 'react';
import { IPortalContext } from '../../../context/portal-context';
import { hasContract, longdriveProduct } from '../../../helpers/servicesHelper';
import { ServiceType, ServiceLayer, ServiceGroupType, defaultServiceLayer } from '../models/services-layer-types';
import {
	longdriveStandardLayer,
	longDriveAdvanceLayer,
	longDriveProLayer,
	longDriveNoInformadoLayer,
	longdriveNoContratadoLayer,
	garantiaVolkswagenLayer,
	idCareLayer,
	recogidaYentregaLayer,
	cocheDeSustitucionLayer,
	expressServiceLayer,
	serviciosTallerLayer,
	itvPorTiLayer,
	checkqueoDeCortesiaLayer,
	preItvLayer,
} from './content-detail-layers';

export const getServiceLayerData = (
	type: ServiceType,
	vehicle: Vehicle,
	portalContext: IPortalContext,
): ServiceLayer => {
	const { userInteractionService } = portalContext;

	switch (type) {
		case ServiceType.AsistenciaCarretera:
			return {
				id: ServiceGroupType.default,
				header: '',
				title: '',
				subtitle: <></>,
			};
		case ServiceType.LongDrive: {
			if (hasContract(vehicle.longdrive?.contractEndDate)) {
				if (longdriveProduct(vehicle) === 'Standard') {
					return longdriveStandardLayer(userInteractionService);
				} else if (longdriveProduct(vehicle) === 'Advance') {
					return longDriveAdvanceLayer(userInteractionService);
				} else if (longdriveProduct(vehicle) === 'Pro') {
					return longDriveProLayer(userInteractionService);
				} else {
					return longDriveNoInformadoLayer;
				}
			} else {
				return longdriveNoContratadoLayer;
			}
		}
		case ServiceType.GarantiaVolkswagen:
			return garantiaVolkswagenLayer(vehicle);

		case ServiceType.IdCare:
			return idCareLayer;

		case ServiceType.RecogidaEntrega:
			return recogidaYentregaLayer;

		case ServiceType.CocheSustitucion:
			return cocheDeSustitucionLayer;

		case ServiceType.ExpressService:
			return expressServiceLayer;

		case ServiceType.Autoservicio:
			return serviciosTallerLayer;

		case ServiceType.ITVporTi:
			return itvPorTiLayer;

		case ServiceType.CheckeoCortesia:
			return checkqueoDeCortesiaLayer;

		case ServiceType.PreItv:
			return preItvLayer;

		default:
			return defaultServiceLayer;
	}
};
